// System Context Utilities
const STORAGE_KEYS = {
  COMPANY_CODE: 'company_code',
  REGION_CODE: 'region_code',
  USER_CODE: 'user_code'
};

/**
 * Loads system context from localStorage
 * @returns {Object} System context object with companyCode, regionCode, userCode
 */
export const loadSystemContext = () => {
  return {
    companyCode: localStorage.getItem(STORAGE_KEYS.COMPANY_CODE) || '',
    regionCode: localStorage.getItem(STORAGE_KEYS.REGION_CODE) || '',
    userCode: localStorage.getItem(STORAGE_KEYS.USER_CODE) || ''
  };
};

/**
 * Saves system context to localStorage
 * @param {Object} context - System context object
 * @param {string} context.companyCode - Company code
 * @param {string} context.regionCode - Region code  
 * @param {string} context.userCode - User code
 */
export const saveSystemContext = (context) => {
  localStorage.setItem(STORAGE_KEYS.COMPANY_CODE, context.companyCode || '');
  localStorage.setItem(STORAGE_KEYS.REGION_CODE, context.regionCode || '');
  localStorage.setItem(STORAGE_KEYS.USER_CODE, context.userCode || '');
};

/**
 * Clears all system context from localStorage
 */
export const clearSystemContext = () => {
  localStorage.removeItem(STORAGE_KEYS.COMPANY_CODE);
  localStorage.removeItem(STORAGE_KEYS.REGION_CODE);
  localStorage.removeItem(STORAGE_KEYS.USER_CODE);
};

/**
 * Checks if system context has any values
 * @param {Object} context - System context object
 * @returns {boolean} True if any context values exist
 */
export const hasSystemContext = (context) => {
  return !!(context.companyCode || context.regionCode || context.userCode);
};

export default {
  loadSystemContext,
  saveSystemContext,
  clearSystemContext,
  hasSystemContext,
  STORAGE_KEYS
};
